import { Spin, Form, Row, Col, Input, Button, message, Select } from "antd";
import get from "lodash/get";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as MESSAGES from "../../../constants/messages";
import * as VALIDATIONS from "../../../constants/data/validations/subDistributorValidations/DistributorsContactValidations";
import map from "lodash/map";
import {
  createDistributorsContact,
  updateDistributorsContact,
} from "../../../redux/actions/allDistributorsAction/distributorContactActions";

const { Option } = Select;
const AddContactForm = ({
  toggalModal,
  initialValues,
  edit,
  onSucessView,
  id,
  contactType,
  getContactType,
}) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const Obj = {
    name: "contactName",
    email: "contactEmail",
    distributor_contact_type_id: "distributorContactTypeId",
  };

  const onFinish = (value) => {
    for (var key in Obj) {
      value[`${key}`] = value[Obj[key]];
      delete value[Obj[key]];
    }

    if (edit) {
      const payload = {
        ...value,
        did: id,
        cid: get(initialValues, "id", 0),
      };
      editDistributorsContact(payload);
    } else {
      const payload = { ...value, did: id };
      AddDistributorsContact(payload);
    }
  };

  const AddDistributorsContact = (payload) => {
    setLoading(true);
    dispatch(createDistributorsContact(payload))
      .then(() => {
        setLoading(false);
        message.success(MESSAGES.CREATE_CONTACT);
        onSucessView();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const editDistributorsContact = (payload) => {
    setLoading(true);
    dispatch(updateDistributorsContact(payload))
      .then(() => {
        message.success(MESSAGES.EDIT_CONTACT);
        setLoading(false);
        onSucessView();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getContactType();
  }, []);

  return (
    <Spin spinning={loading}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        scrollToFirstError
        initialValues={
          edit
            ? {
                ...initialValues,
                contactName: get(initialValues, "name", ""),
                contactEmail: get(initialValues, "email", ""),
                distributorContactTypeId: get(
                  initialValues,
                  "distributor_contact_type_id",
                  0
                ),
              }
            : {
                is_active: false,
              }
        }
      >
        <Row gutter={16}>
          <Col xl={24} xs={24}>
            <Row gutter={16}>
              <Col xl={12} xs={12}>
                <Form.Item
                  name="contactName"
                  label="Name"
                  rules={VALIDATIONS.DISTRIBUTOR_CONTACT_NAME_VALIDATIONS}
                >
                  <Input size="large" />
                </Form.Item>
              </Col>
              <Col xl={12} xs={12}>
                <Form.Item
                  name="contactEmail"
                  label="Email"
                  rules={VALIDATIONS.DISTRIBUTOR_CONTACT_EMAIL_VALIDATIONS}
                >
                  <Input size="large" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xl={24} xs={24}>
                <Row gutter={16}>
                  <Col xl={12} xs={12}>
                    <Form.Item
                      name="phone"
                      label="Phone Number"
                      rules={VALIDATIONS.DISTRIBUTOR_CONTACT_PHONE_VALIDATIONS}
                    >
                      <Input size="large" />
                    </Form.Item>
                  </Col>
                  <Col xl={12} xs={12}>
                    <Form.Item
                      name="distributorContactTypeId"
                      label="Contact Type"
                      rules={VALIDATIONS.DISTRIBUTOR_CONTACT_TYPE_VALIDATIONS}
                    >
                      <Select
                        size="large"
                        showSearch={true}
                        optionFilterProp="children"
                      >
                        {map(contactType, (rt) => (
                          <Option key={get(rt, "id")} value={get(rt, "id")}>
                            {get(rt, "name")}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Form.Item label="">
                <Button
                  htmlType="submit"
                  type="primary"
                  className={edit ? "edit-user-button" : "add-user-button"}
                  size="large"
                >
                  {edit ? "UPDATE" : "ADD"}
                </Button>
              </Form.Item>

              <Form.Item label="">
                <Button
                  className="cancel-btn"
                  onClick={toggalModal}
                  size="large"
                  type="primary"
                  style={{
                    height: 50,
                    width: 150,
                    marginLeft: 10,
                  }}
                >
                  CANCEL
                </Button>
              </Form.Item>
            </div>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default AddContactForm;
